<template>
  <DetailsAsideLayout>
    <template v-slot:detailsContent>
      <ConfigurationDescription
        :parentType="parentType"
      />
      <ConfigurationSettings
        :parentType="parentType"
      />
    </template>
  </DetailsAsideLayout>
</template>
<script>
import { ItemTypeConsts } from 'client/util/Constants';
import ConfigurationDescription from 'client/policies/components/ConfigurationDescription.vue';
import ConfigurationSettings from 'client/policies/components/ConfigurationSettings.vue';
import DetailsAsideLayout from 'client/components/AsidePanel/Details/DetailsAsideLayout.vue';

export default {
  name: 'ConfigurationDetails',

  inject: ['$validator'],

  components: {
    ConfigurationDescription,
    ConfigurationSettings,
    DetailsAsideLayout,
  },

  data() {
    return {
      parentType: ItemTypeConsts.configuration,
    };
  },
};
</script>
